import { BlankState } from "../BotAnalyticsDashboard";
import { TopIntents } from "../Helpers/DataHelpers";
import { BarAndPieChart } from "../../Charts/BarAndPieChart/BarAndPieChart";
import { Spinner } from "@swivl-mono/ui";

export const Intent = ({nlpData, onViewAll, className}) => {
    let content, total, viewAll;
    if (nlpData) {
      if (!nlpData.total || !nlpData.total.total) {
        content = <div className="loadingContent ">{BlankState()}</div>;
      } else {
        const data = TopIntents(nlpData);
        total = nlpData.total.total.toLocaleString();
        content = (
          <div className="barAndPieWapper">
            <BarAndPieChart data={data} showTotals={true} width={580} height={200} />
          </div>
        );
        viewAll = (
          <a className="viewAll" onClick={onViewAll}>
            VIEW ALL
          </a>
        );
      }
    } else {
      content = (
        <div className="loadingContent">
          <Spinner />
        </div>
      );
    }
    return (
      <div className={`chartBox ${className || ''}`}>
        <div className="chartHeader">
          <div className="chartHeaderTitle">
            {" "}
            <span>Top User Intents</span>{" "}
          </div>
          <div className="spacer" />
          <div className="headerTotal">{total}</div>
        </div>
        <div className="chartContent">{content}</div>
        {/* {viewAll} */}
      </div>
    );
  }